import { render, staticRenderFns } from "./BFingerprintDialog.vue?vue&type=template&id=ea275430"
import script from "./BFingerprintDialog.vue?vue&type=script&lang=js"
export * from "./BFingerprintDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports